export default __webpack_public_path__ + "static/media/splash.d46d4544.svg";